import { render } from "./modal_selectprice.vue?vue&type=template&id=dfa8f32c&scoped=true"
import script from "./modal_selectprice.vue?vue&type=script&lang=js"
export * from "./modal_selectprice.vue?vue&type=script&lang=js"

import "./modal_selectprice.vue?vue&type=style&index=0&id=dfa8f32c&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfa8f32c"]])

export default __exports__